/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import { Text, Button, Icon, TextInput } from '../uiold';
import { themeColors } from '../uiold/Constants';

import Dropdown from '../uiold/DropdownSimple';
import Infotip from '../uiold/Infotip';
import ItemForm from '../ItemForm';

import SignupFormModel from './SignupFormModel';
import { Group } from '../../types/shared/Group';
import { OptionValue } from '../../types/FormBuilder/FormElements';

type Option = {
  id: string;
  name: string;
};

type SelectedCriteria = {
  id: string;
  value: unknown;
};

type Props = {
  group: Group;
  formDef: SignupFormModel;
  onChange: (newGroup: Group) => void;
  onSave: () => void;
  onCancel: () => void;
};

const DISPLAY_ALWAYS = 'Always';
const DISPLAY_CONDITIONALLY = 'Conditionally';
const DEFAULT_CRITERIA = {
  field_id: '',
  field_value: null,
};
const EMPTY_OPTIONS_VALUE_LIST: Array<OptionValue> = [];

class FieldGroupEditor extends Component<Props> {
  render() {
    let { group, onSave, onCancel } = this.props;
    let isSaveDisabled = group.fields.length < 1;
    let conditionality = group.criteria
      ? DISPLAY_CONDITIONALLY
      : DISPLAY_ALWAYS;
    return (
      <ItemForm style={styles.container}>
        <ItemForm.Header noline style={styles.fieldHeader}>
          <View style={{ flexDirection: 'row' }}>
            <TouchableOpacity onPress={onCancel}>
              <Icon name="arrowBack" size="S" />
            </TouchableOpacity>
            <Text accessibilityRole="label" style={styles.groupText}>
              <Text>Create Group </Text>
              <Infotip
                width={150}
                text="Select at least one field to create a group."
              />
            </Text>
          </View>
        </ItemForm.Header>
        <ItemForm.Body>
          <View accessibilityRole="label" style={styles.field}>
            <Text style={styles.label}>Title</Text>
            <TextInput
              autoFocus={true}
              value={group.title}
              onChangeText={(text) => this._onChange({ title: text })}
            />
          </View>
          <View accessibilityRole="label" style={styles.field}>
            <Text style={styles.label}>Show this group</Text>
            <Dropdown
              options={[DISPLAY_ALWAYS, DISPLAY_CONDITIONALLY]}
              selectedItem={conditionality}
              onChange={this._onConditionalityChange}
            />
          </View>
          {this._renderCriteriaSelector()}
        </ItemForm.Body>
        <ItemForm.Footer>
          <View style={styles.footer}>
            <Button onPress={onCancel} title="Cancel" />
            <Button onPress={onSave} isDisabled={isSaveDisabled} title="Save" />
          </View>
        </ItemForm.Footer>
      </ItemForm>
    );
  }

  _onConditionalityChange = (conditionality: string) => {
    if (conditionality === DISPLAY_ALWAYS) {
      this._onChange({ criteria: null });
    } else {
      let {
        selectedField,
        selectedFieldOption,
      } = this._getCriteriaSelectorStuff();
      this._onChange({
        criteria: {
          field_id: selectedField ? selectedField.id : null,
          field_value: selectedFieldOption ? selectedFieldOption.id : null,
        },
      });
    }
  };

  _renderCriteriaSelector = () => {
    let { group } = this.props;
    if (group.criteria == null) {
      return;
    }
    let {
      filteredFields,
      selectedField,
      fieldOptions,
      selectedFieldOption,
    } = this._getCriteriaSelectorStuff();
    if (filteredFields.length === 0) {
      return (
        <View>
          <Text>No eligible form elements to choose from.</Text>
        </View>
      );
    }

    return (
      <View>
        <View>
          <Text>Show only when:</Text>
          <View>
            <Dropdown
              options={filteredFields}
              selectedItem={selectedField}
              onChange={this._onCriteriaFieldSelect}
            />
          </View>
        </View>
        <View>
          <Text>is equal to:</Text>
          <View>
            <Dropdown
              options={fieldOptions}
              selectedItem={selectedFieldOption}
              onChange={this._onCriteriaValueSelect}
            />
          </View>
        </View>
      </View>
    );
  };

  _getCriteriaSelectorStuff = () => {
    let { formDef } = this.props;
    let criteria = this._getCriteria();
    let filteredFields = this._getFilteredFields();
    let criteriaField = this._getCriteriaField();
    let criteriaFieldID = criteriaField ? criteriaField.id : null;
    if (criteriaFieldID == null && filteredFields.length) {
      criteriaFieldID = filteredFields[0]?.id ?? '';
      criteriaField = formDef.fields.getByID(criteriaFieldID);
    }
    let selectedField = filteredFields.find(
      (item) => item.id === criteriaFieldID,
    );
    let fieldOptions = criteriaField
      ? criteriaField.getValueAsOptions()
      : EMPTY_OPTIONS_VALUE_LIST;
    let selectedFieldOption = fieldOptions.find(
      (optionValue: any) => optionValue.id === criteria.field_value,
    );
    if (selectedFieldOption == null && fieldOptions.length) {
      selectedFieldOption = fieldOptions[0];
    }
    return {
      filteredFields,
      selectedField,
      fieldOptions,
      selectedFieldOption,
    };
  };

  _getFilteredFields = (): Array<Option> => {
    let { formDef } = this.props;
    // only allow a multi-choice field
    let fields = formDef.fields.filter((field) => {
      let { type } = field.definition;
      return type === 'BooleanElement' || type === 'MultichoiceElement';
    });
    return fields.mapToArray((field) => {
      let { id, definition } = field;
      let name = typeof definition.name === 'string' ? definition.name : '';
      return { id, name };
    });
  };

  _getCriteriaField = (selectedField?: Option | null | undefined) => {
    let { formDef } = this.props;
    let criteria = this._getCriteria();
    let formFieldID = selectedField ? selectedField.id : criteria.field_id;
    return formFieldID ? formDef.fields.getByID(formFieldID) : null;
  };

  _onCriteriaFieldSelect = (selectedItem: Option) => {
    let { group } = this.props;
    let { id, value } = this._getSelectedCriteriaField(selectedItem);
    this.props.onChange({
      ...group,
      criteria: {
        field_id: id,
        field_value: value,
      },
    });
  };

  _onCriteriaValueSelect = (selectedItem: OptionValue) => {
    let { group } = this.props;
    let { id, value } = this._getSelectedCriteriaField(null, selectedItem);
    this.props.onChange({
      ...group,
      criteria: {
        field_id: id,
        field_value: value,
      },
    });
  };

  _getSelectedCriteriaField = (
    selectedField: Option | null | undefined,
    selectedOption?: OptionValue,
  ): SelectedCriteria => {
    let { formDef } = this.props;
    let criteria = this._getCriteria();
    let filteredFields = this._getFilteredFields();
    let criteriaField = this._getCriteriaField(selectedField);
    if (criteriaField == null && filteredFields.length) {
      criteriaField = formDef.fields.getByID(filteredFields[0]?.id ?? '');
    }
    if (criteriaField == null) {
      return { id: '', value: null };
    }
    let fieldOptions = criteriaField.getValueAsOptions();
    let searchValue = selectedOption ? selectedOption.id : criteria.field_value;
    let selectedFieldOption =
      fieldOptions.find((option: any) => option.id === searchValue) ||
      fieldOptions[0];
    return {
      id: criteriaField.id,
      value: selectedFieldOption ? selectedFieldOption.id : null,
    };
  };

  _getCriteria = () => this.props.group.criteria || DEFAULT_CRITERIA;

  _onChange = (updates: Partial<Group>) => {
    let { group, onChange } = this.props;
    let newGroup = {
      ...group,
      ...updates,
    };
    onChange(newGroup);
  };
}

let styles = StyleSheet.create({
  container: {
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.borderGrey,
  },
  field: {
    marginBottom: 12,
  },
  label: {
    fontWeight: 'normal',
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  fieldHeader: {
    borderBottomColor: themeColors.borderGrey,
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  groupText: {
    marginLeft: 10,
  },
});

export default FieldGroupEditor;
